import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/common/Layout'
import Home from './pages/Home'
import About from './pages/About'
import Programs from './pages/Programs'
import Admissions from './pages/Admissions'
import Contact from './pages/Contact'
import ExpoGardenias from './pages/ExpoGardenias'
import ExpoGardeniasUpload from './pages/ExpoGardeniasUpload'
import Areas from './pages/Areas'
import Bienestar from './pages/Bienestar'
import Revistas from './pages/Revistas'
import ExpoGardeniasPopup from './components/common/ExpoGardeniasPopup'
//import MatriculasModal from './components/common/MatriculasModal'

function App() {
  return (
    <Router>
      {/* Modal de matrículas - aparece al cargar la web */}
      {/*<MatriculasModal />*/}

      {/* Popup de ExpoGardenias - aparece una vez por sesión al cargar la web */}
      <ExpoGardeniasPopup />

      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<About />} />
          <Route path="/expogardenias" element={<ExpoGardenias />} />
          <Route path="/expogardenias/subir" element={<ExpoGardeniasUpload />} />
          <Route path="/areas" element={<Areas />} />
          <Route path="/bienestar" element={<Bienestar />} />
          <Route path="/revistas" element={<Revistas />} />
          <Route path="/programas" element={<Programs />} />
          <Route path="/admisiones" element={<Admissions />} />
          <Route path="/contacto" element={<Contact />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App